import pic1 from "./gallery/pic1.jpg";
import pic2 from "./gallery/pic2.jpg";
import pic3 from "./gallery/pic3.jpg";
import pic4 from "./gallery/pic4.jpg";
import pic5 from "./gallery/pic5.jpg";
import pic6 from "./gallery/pic6.jpg";
import pic7 from "./gallery/pic7.jpg";
import pic8 from "./gallery/pic8.jpg";
import pic9 from "./gallery/pic9.jpg";
import pic10 from "./gallery/pic10.jpg";
import pic11 from "./gallery/pic11.jpg";
import pic12 from "./gallery/pic12.jpg";
import pic13 from "./gallery/pic13.jpg";

export const photos = [
  {
    src: pic1,
    height: 3,
    width: 4,
  },
  {
    src: pic10,
    height: 4,
    width: 3,
  },

  {
    src: pic3,
    height: 4,
    width: 3,
  },
  {
    src: pic8,
    height: 4,
    width: 3,
  },
  {
    src: pic7,
    height: 9,
    width: 16,
  },
  {
    src: pic4,
    height: 4,
    width: 3,
  },
  {
    src: pic5,
    height: 3,
    width: 4,
  },

  {
    src: pic6,
    height: 3,
    width: 4,
  },
  {
    src: pic9,
    height: 4,
    width: 3,
  },
  {
    src: pic11,
    height: 3,
    width: 4,
  },
  {
    src: pic12,
    height: 4,
    width: 3,
  },
  {
    src: pic13,
    height: 3,
    width: 4,
  },
  {
    src: pic2,
    height: 9,
    width: 16,
  },
];
